import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

import deferRender from 'defer-render-hoc';
import { withRouter } from 'react-router-dom';

import {
  __getGroupedByDate,
  getNextPageLink,
  getIsJourneysLoading,
  getIsJourneysError,
  getJourneyFields,
  getJourneyAdditionalDocumentsFields,
  getJourneyStopFields,
  getIsNextPageLoading,
} from 'redux/modules/journeys/selectors';

import { getAssignedFilters } from 'redux/modules/jobs/selectors';

import { journeyCardEnhancer } from 'modules/journey/card/hoc';

import Assigned from './component';

const selectors = {
  getJourneyFields,
  getJourneyAdditionalDocumentsFields,
  getJourneyStopFields,
  getFilters: getAssignedFilters,
};

const enhance = compose(
  injectIntl,
  deferRender,
  withRouter,
  journeyCardEnhancer(selectors),
  connect((state) => {
    const filters = getAssignedFilters(state);
    const nextPage = getNextPageLink(state);
    const isDispatcher = ((state.me || {}).groups || []).includes('Dispatcher');
    return {
      filters,
      loading: getIsJourneysLoading(state),
      hasError: getIsJourneysError(state),
      grouped: __getGroupedByDate(state, filters),
      nextPageLoading: getIsNextPageLoading(state),
      nextPage,
      isDispatcher,
    };
  })
);

export default enhance(Assigned);
